import React from 'react';
import {useTranslation} from 'react-i18next';
import {TShow} from '../../../../hooks/useShow';
import {getWalletLink} from '../../../../redux/eTicket/eTicketActions';
import GoogleWalletBadge from '../../../../assets/icons/GoogleWalletBadge';
import SheetShell from '../SheetShell/SheetShell';
import * as css from './WalletSheet.css';

interface WalletSheetProps {
    show: TShow;
    token: string;
}

function WalletSheet({show, token}: WalletSheetProps): React.ReactElement {
    const {t} = useTranslation('eTicket');

    const openGoogleWallet = () => {
        const tab = window.open('', '_blank');
        getWalletLink(token).then(link => {
            if(link && tab) tab.location.href = link;
            else tab?.close();
        });
    };

    return (
        <SheetShell show={show} title={t('walletTitle')} data-cy="ticket-fab-wallet-sheet">
            <css.content>
                <css.description>{t('walletDescription')}</css.description>
                <css.badge type="button" onClick={openGoogleWallet} aria-label="Google Wallet" data-cy="ticket-fab-wallet-google">
                    <GoogleWalletBadge />
                </css.badge>
            </css.content>
        </SheetShell>
    );
}

export default WalletSheet;
